module.exports = __webpack_public_path__ + "img/timeline-event-filebrowser.fa6e6c85.png";